export const CurrencyIcon =
  {
    CLP: "$",
    USD: "US",
    EUR: "€",
    GBP: "£",
    UF: "UF",
    MXN: "$",
    UTM: "UTM",
    ARS: "$",
    CNY: "¥",
    JPY: "¥",
    PEN: "S/",
    BRL: "R$",
    COP: "$",
    CAD: "C$",
    UYU: "$U",
  } || "$";
